/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum RevenueType1 {
    TruckLoad = 1,
    Dedicated = 2,
    Expedite = 3,
    Brokerage = 4,
    Specialized = 5,
    TLBrokerage = 6,
    CrossDock = 7,
}
